import { paths } from "../../config/paths";
import { LandingPage } from "../../features/landing-page/LandingPage";
import { useTranslation } from "../../lib/i18n";

export const FragranceProfilerHome = () => {
  const { t } = useTranslation();

  return (
    <LandingPage
      backgroundPath="/fragrance-profiler/landing-page.webm"
      subtitle={t('landing.fragranceProfiler.subtitle')}
      title={t('landing.fragranceProfiler.title')}
      description={t('landing.fragranceProfiler.description')}
      path={paths.fragranceProfiler.profiler.path}
    />
  );
};
